import { DrillDownTable } from './drill-down-table/drill-down-table';
import { NgModule } from '@angular/core';
import { DatePickerModal } from './data.picker.modal';
import { CommonTableModel } from './common-table/common-table';
import { CommonXYChartModel } from './common-xy-chart/common-xy-chart';
import { EventGraphModal } from './event.graph.modal';
import { IonicModule } from '@ionic/angular';
import { DateToolbarComponent } from './date.toolbar.component';
import { NgMultiSelectDropDownModule } from './mulitselect';
import { CommonDropdownComponent } from './common.dropdown.component';
import { DateSelectorComponent } from './date-selector/date.selector.component';
import { CommonModule } from '@angular/common';
import { UICompModule } from '../ui-components/ui-components.module';
import { TimeGranularitySelector } from './granularity-selector/time-granularity-selector';
import { CommonHeader } from './common-header/common-header';
import { HeaderSettingPopover } from './header-setting-popover/header-setting-popover';
import { ShiftSelectorModal } from './shift-selector/shift-selector-modal';
import { ZFInfoTabs } from './zf-info-tabs/zf-info-tabs';
import { DataSelector } from './data-selector/data-selector';
import { GraphLegend } from './graph-legend/graph-legend';
import { NgxDaterangepickerMd } from '../daterangepicker/daterangepicker.module';
import { FormsModule } from '@angular/forms';
import { PopOverPage } from './pop-over/pop-over';
import { ChartingModule, UiModule } from '@monorepo/ui';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslationLoaderFactory } from '@monorepo/services';
import { AiAnalyticsModalComponent } from './ai-analytics-modal/ai-analytics-modal.component';
import { ChatUiModule } from '@monorepo/ui/chat-ui';
import { TableGraphViewModalComponent } from './table-graph-view-modal/table-graph-view-modal.component';

@NgModule({
  declarations: [
    DatePickerModal,
    CommonTableModel,
    CommonXYChartModel,
    GraphLegend,
    DataSelector,
    EventGraphModal,
    DateToolbarComponent,
    CommonDropdownComponent,
    DateSelectorComponent,
    TimeGranularitySelector,
    DrillDownTable,
    HeaderSettingPopover,
    CommonHeader,
    ShiftSelectorModal,
    ZFInfoTabs,
    PopOverPage,
    AiAnalyticsModalComponent,
    TableGraphViewModalComponent,
  ],
  exports: [
    DatePickerModal,
    EventGraphModal,
    DateToolbarComponent,
    CommonDropdownComponent,
    DateSelectorComponent,
    CommonTableModel,
    CommonXYChartModel,
    GraphLegend,
    DataSelector,
    TimeGranularitySelector,
    DrillDownTable,
    CommonHeader,
    ShiftSelectorModal,
    ZFInfoTabs,
    PopOverPage,
    TranslateModule,
    AiAnalyticsModalComponent,
    TableGraphViewModalComponent,
  ],
  imports: [
    NgxDaterangepickerMd,
    IonicModule,
    NgMultiSelectDropDownModule.forRoot(),
    CommonModule,
    UICompModule,
    FormsModule,
    UiModule,
    ChatUiModule,
    ChartingModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => {
          const factory = new TranslationLoaderFactory(http);
          return factory.createForApp('oi-app');
        },
        deps: [HttpClient],
      },
    }),
  ],
  providers: [HeaderSettingPopover],
})
export class OICommonModule {}
